type RowTransform = (ids: any[], change?: (v: any) => any) => any[];

export default RowTransform;

export const noTransform = (foo: string[]) => foo;
